import { render, staticRenderFns } from "./promptlyPayment.vue?vue&type=template&id=389c34dc&scoped=true&"
import script from "./promptlyPayment.vue?vue&type=script&lang=js&"
export * from "./promptlyPayment.vue?vue&type=script&lang=js&"
import style0 from "./promptlyPayment.vue?vue&type=style&index=0&id=389c34dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389c34dc",
  null
  
)

export default component.exports